import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import options from './options';
import { baseState } from './optionsBase';
import dataSettingsDialog from './dataSettingsDialog';
import { cityCrimes, censusCrimes } from './crimes';
import timeBounds from './timeBounds';
import crimeTypes from './crimeTypes';
import cities from './cities';
import population from './population';
import chart from './chart';
import exportDialog from './exportDialog';
import mapViewport from './mapViewport';
import { types as dataSettingsDialogTypes } from '../actions/dataSettingsDialog';

const combinedReducers = combineReducers({
  options,
  dataSettingsDialog,
  cityCrimes,
  censusCrimes,
  timeBounds,
  crimeTypes,
  mapViewport,
  population,
  router: routerReducer,
  chart,
  exportDialog,
  cities,
});

export default (state, action) => {
  const interState = combinedReducers(state, action);

  const { type } = action;

  switch (type) {
    case dataSettingsDialogTypes.OPEN_DATA_SETTINGS_DIALOG:
      return {
        ...interState,
        dataSettingsDialog: {
          ...interState.dataSettingsDialog,
          ...baseState(interState.options),
        },
      };

    case dataSettingsDialogTypes.APPLY_DATA_SETTINGS_DIALOG:
      return {
        ...interState,
        options: {
          ...interState.options,
          ...baseState(interState.dataSettingsDialog),
        },
      };

    default:
      return interState;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/index.js